import React from 'react'
import { Form } from 'react-final-form'
import { InputField, Row, DropdownField, TextareaField, VALIDATORS, Error } from '../../components/Fields'
import { LocationsQuery, getStateName } from '../../core'

import './book-a-tour.scss'

const EnterpriseInquiry = ({ 
  data = {}, 
  context = {}, 
}) => {

  const { handleSubmit } = data

  const onSubmit = (values) => {
    console.log('submit enterprise', values)
  }
  
  return (
    <div styleName="book-a-tour">
      <h3>Let&rsquo;s Find You the Perfect Space</h3>
      <Form
        onSubmit={onSubmit}
        render={({ 
          handleSubmit, 
          hasValidationErrors,
          submitFailed,
          dirtySinceLastSubmit,
        }) => (
          <form styleName='booking-form' onSubmit={handleSubmit}>
            <Row>
              <InputField
                name='fullName'
                label='Full Name'
                isRequired
              />
              <InputField
                name='email'
                label='Email'
                validators={[VALIDATORS.email]}
                isRequired
              />
            </Row>

            <Row>
              <InputField
                name='contactNumber'
                label='Contact Number'
                isRequired
              />
              <InputField
                name='moveInDate'
                label='Desired Move-In Date'
                placeholder='YYYY-MM-DD'
              />
            </Row>

            <Row>
              <LocationsQuery
                render={({ data }) => (
                  <DropdownField
                    name='preferredLocation'
                    label='Preferred Location'
                    options={[
                      ...data.locations
                        .filter(o => o.address && o.address.state)
                        .map(o => ({
                          name: o.title,
                          value: o.title,
                          subcategory: getStateName(o.address && o.address.state),
                        })),
                      { name: 'Undecided', value: 'Undecided' },
                    ]}
                    validators={[val => val ? undefined : 'Please select location']}
                  />
                )}
              />
              <InputField
                name='teamSize'
                label='Estimated Team Size'
              />
            </Row>

            <Row>
              <TextareaField
                name='additionalQuestions'
                label='Additional Requirements or Questions'
              />
            </Row>

            <button
              styleName="submit-button" 
              data-theme="ivory"
              type="submit" 
            >
              Submit
            </button>
            {submitFailed
              && hasValidationErrors 
              && <Error>Please fix required fields</Error>
            }
          </form>
        )}
      />
    </div>
  )
}

export default EnterpriseInquiry
